var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentSearch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.133 47.2H17.356A4.356 4.356 0 0 1 13 42.844V12.356A4.356 4.356 0 0 1 17.356 8H29.52c.578 0 1.132.23 1.54.638l11.791 11.79c.408.41.638.963.638 1.54v16.876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M30 8v11a2 2 0 0 0 2 2h11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m42 45-5.333-5.333m1.777-4.445a6.222 6.222 0 1 1-12.444 0 6.222 6.222 0 0 1 12.444 0"
  })));
};
export default SvgDocumentSearch;